var path = 'app/scripts/modules/core/src/pipeline/config/stages/bake/bakeExecutionHandler.html';
var html = "<div class=\"form-group\">\n  <label class=\"col-md-4 sm-label-right\">Rebake</label>\n  <div class=\"checkbox col-md-6\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.command.trigger.rebake\"/>\n      Force Rebake\n    </label>\n    <help-field key=\"execution.forceRebake\"></help-field>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/bake/bakeExecutionHandler.html
// module id = 997
// module chunks = 0